import { TableFooter, TableRow, TableCell } from "@mui/material";
import useGrandTotal from "../../hooks/useGrandTotal";
import { NumberField, RecordContextProvider, TextField } from "react-admin";

const SalesmanPenaltyDetailFooterList = () => {
  const { data } = useGrandTotal();

  return (
    <RecordContextProvider value={data ? data : {}}>
      <TableFooter>
        <TableRow
          sx={{
            "& td": {
              borderTop: "1px solid rgba(224, 224, 224, 1) !important",
            },
            "& .MuiTypography-root": {
              color: (theme) => theme.palette.primary.main,
              fontWeight: "bold",
            },
          }}
        >
          <TableCell></TableCell>
          <TableCell sx={{ whiteSpace: "nowrap" }}>
            <RecordContextProvider value={{ name: "GRAND TOTAL" }}>
              <TextField source="name" />
            </RecordContextProvider>
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="target_qty" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="gross_qty" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="return_qty" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="net_qty" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="gross_value" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="return_value" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="correction_value" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="net_value" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="total_payment" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="total_ret_pot" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="total_penalty_lte_90" textAlign="right" />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField
              source="total_penalty_gt_90_lte_120"
              textAlign="right"
            />
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="total_penalty_gt_120" textAlign="right" />
          </TableCell>
        </TableRow>
      </TableFooter>
    </RecordContextProvider>
  );
};

export default SalesmanPenaltyDetailFooterList;
